/**
 * Bunker brand mark (new logo). Inline SVG with `fill="currentColor"` so it
 * adapts to ANY background via the parent's text color — white on dark themes,
 * near-black on light — one asset for both. Colour it with `text-foreground`
 * (neutral) or `text-accent` (brand cyan) on the wrapper.
 */
export function BunkerLogo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 513 363"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <path d="M474.152 0C515.59 9.56289 515.324 43.8288 510.012 59.7666L478.137 147.425L422.354 183.285L454.229 219.146C448.917 243.052 435.104 297.241 422.354 322.741C409.603 348.242 382.509 359.93 370.556 362.586H0L56.6523 190.741L173.865 233.181L156.803 270.942H286.883L290.456 261.817L69.335 152.271L119.534 0H474.152ZM219.146 135.259H326.727L336.716 126.437L342.614 103.296L338.467 91.6426H239.068L219.146 135.259Z" />
    </svg>
  );
}
